import type { IFaqCategory } from './faq-types';

export const faqAccount: IFaqCategory = {
  title: 'Account & Privacy',
  slug: 'account-and-privacy',
  items: [
    {
      question: 'How do I delete my account?',
      answer:
        'You can delete your account from the Profile tab in the app under Settings. You can also request deletion by emailing our support team. Please cancel any active subscriptions in your device settings before deleting your account to avoid further charges.',
    },
    {
      question: 'What happens to my data when I delete my account?',
      answer:
        'All your personal data, learning progress, review history, and account information will be permanently deleted. This action cannot be undone.',
    },
    {
      question: 'Can I recover my account after deletion?',
      answer:
        'No. Once your account is deleted, there is no way to recover it. You would need to create a new account and start from scratch.',
    },
    {
      question: 'How long does account deletion take?',
      answer:
        'Your account is deleted immediately. All associated data is purged from our servers within 30 days in accordance with our privacy policy.',
    },
    {
      question: 'Where can I find the Privacy Policy and Terms of Use?',
      answer:
        'You can find our Privacy Policy at yocoolmate.com/privacy and Terms of Use at yocoolmate.com/terms. In the app, these are available in the Profile tab under settings.',
    },
  ],
};
